import { MigrationStoreRow } from '../../../app/models/Admin';

// Current PFV1 scope set. Editable in the directory when reviewing another set.
export const legacyRequiredScopes = 'write_customers,write_products,write_script_tags,write_app_proxy';
export const parseScopes = (value: string) => Array.from(new Set(value.toLowerCase().split(/[\s,]+/).filter(Boolean)));
export const hasScope = (granted: string[], required: string) => granted.includes(required)
  || (required.startsWith('read_') && granted.includes(`write_${required.slice(5)}`));
export function permissionStatus(row: MigrationStoreRow, required: string[]) {
  if (!required.length || row.grantedScopes == null || !row.scopesCheckedAt) return 'unknown';
  return required.every(scope => hasScope(row.grantedScopes!, scope)) ? 'approved' : 'missing';
}
export function sortByLogin(rows: MigrationStoreRow[], order: string) {
  if (order === 'name') return rows;
  const timestamp = (value?: string | null) => value
    ? Date.parse(/(?:Z|[+-]\d{2}:\d{2})$/i.test(value) ? value : value + 'Z') : NaN;
  return [...rows].sort((a, b) => {
    // PFV1's historic values have no UTC offset; retain source-server wall time.
    const at = timestamp(a.lastAdminLoginAt);
    const bt = timestamp(b.lastAdminLoginAt);
    if (!Number.isFinite(at)) return Number.isFinite(bt) ? 1 : a.key.localeCompare(b.key);
    if (!Number.isFinite(bt)) return -1;
    return (order === 'oldest' ? at - bt : bt - at) || a.key.localeCompare(b.key);
  });
}
